import React from "react";
import ReactDOM from "react-dom/client";
import Calendar from "../../components/calendar/Calendar";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <App></App>
    </React.StrictMode>
);

function App() {
    return <Calendar />;
}